import { Injectable } from '@angular/core';

export interface DatePickerNoteModule {
  note?: string;
  [key: string]: unknown;
}

interface DatePickerNoteEntry {
  module: DatePickerNoteModule;
  note: string;
}

@Injectable({ providedIn: 'root' })
export class DatePickerNoteService {
  private notes: Record<string, DatePickerNoteEntry> = {};

  init(): boolean {
    return true;
  }

  register(id: string, module?: DatePickerNoteModule): void {
    this.create(id);
    if (module) {
      this.notes[id] = { module, note: '' };
    }
  }

  create(id: string): void {
    if (!this.notes[id]) {
      this.notes[id] = { module: {}, note: '' };
    }
  }

  update(id: string, note?: string, module?: DatePickerNoteModule): void {
    this.create(id);

    if (note) {
      this.notes[id].note = note;
    }

    if (module) {
      this.notes[id].module = module;
    }

    if (this.notes[id].module) {
      this.notes[id].module.note = note;
    }
  }
}
